export default __webpack_public_path__ + "static/media/Ct3.e7517301.png";